import { apiHubBaseUrl, request } from '@/libs/api-request'

export function getDomains (sid, force) {
  let url = '/ba/domain/get_list'

  const config = {
    method: 'post',
    url,
    data: { sid }
  }

  return request(config, force)
}

export function getData (sid, force) {
  let url = `/ba/domain/${sid}`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function insertDomain (params, force) {
  let url = '/ba/domain/insert_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteDomain (params, force) {
  let url = '/ba/domain/delete_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function mainDomain (params, force) {
  let url = '/ba/domain/main_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function changeState (params, force) {
  let url = '/ba/domain/change_state'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function validateDomain (params, force) {
  let url = '/ba/domain/validate_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function checkInstall (params, force) {
  let url = '/ba/domain/check_install'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getCode (sid, force = true) {
  let url = `/ba/domain/get_code/${sid}`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getCodeV2 (userNum, force = true) {
  let url = `/ba/domain/get_code_v2/${userNum}`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getGraphInfo (params, force) {
  let url = '/ba/dashboard/info'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAiCategorySummary (params) {
  let url = '/ai/journeymap/get_ai_category_summary'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config)
}

export function getTotalPvPageCount (params) {
  let url = '/ai/journeymap/get_total_pv_page_count'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config)
}

export function getTextosphere (params, force = true) {
  let url = '/ai/journeymap/get_textosphere'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

// share domain api

export function getPathData (params, force = true) {
  let url = '/ba/domain/domain_path_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function addSharedUser (params, force = true) {
  let url = '/ba/domain/shared_check'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSharedUsers (params, force = true) {
  let url = '/ba/domain/shared_data_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSelectedUserData (params, force = true) {
  let url = '/ba/domain/selected_user_data_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSharedUserCount (params, force = true) {
  let url = '/ba/domain/shared_data_count'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function setSharedDomain (params, force = true) {
  let url = '/ba/domain/share_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
export function extendDomain (params, force = true) {
  let url = '/ba/domain/extend_domain'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAdParamConfig (params = {}, force = true) {
  const url = `${apiHubBaseUrl()}/v1/journeymap/common/get_ad_param_config`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function updateAdParamConfig (params, force = true) {
  const url = `${apiHubBaseUrl()}/v1/journeymap/common/update_ad_param_config`

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteSharedUser (params, force = true) {
  let url = '/ba/domain/delete_share'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
export function updateSharedUser (params, force = true) {
  let url = '/ba/domain/update_share'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
